import { appendQueryParams } from '@/helpers/query-string';
import { ExtendedContact } from '@/types';

import { CURRENT } from './constants/companyMembership';

const addContactTracking = (origin: string) => (contact: ExtendedContact) => {
  if (contact?.user?.connectionDegree === 1) {
    const contactType = contact.companyMembership === CURRENT ? 'jobs_current_employee' : 'jobs_former_employee';

    return {
      ...contact,
      user: {
        ...contact.user,
        url: appendQueryParams(
          `/profile/${contact?.user?.slug}${
            contact?.user?.clickReasonProfileUrlFromEntity?.code
              ? `/${contact.user?.clickReasonProfileUrlFromEntity?.code}`
              : ''
          }`,
          {
            sc_o: origin,
            sc_o_PropActionOrigin: contactType,
          }
        ),
      },
    };
  }

  return {
    ...contact,
    connectedBy: contact?.connectedBy?.map((edge) => {
      return {
        ...edge,
        user: {
          ...edge.user,
          url: appendQueryParams(
            `/profile/${edge?.user?.slug}${
              edge.user?.clickReasonProfileUrlFromEntity?.code
                ? `/${edge.user?.clickReasonProfileUrlFromEntity?.code}`
                : ''
            }`,
            {
              sc_o: origin,
              sc_o_PropActionOrigin: 'jobs_1st_degree_contact',
            }
          ),
        },
      };
    }),
    user: {
      ...contact.user,
      url: appendQueryParams(
        `/profile/${contact?.user?.slug}${
          contact?.user?.clickReasonProfileUrlFromEntity?.code
            ? `/${contact.user.clickReasonProfileUrlFromEntity.code}`
            : ''
        }`,
        {
          sc_o: origin,
          sc_o_PropActionOrigin: 'jobs_2nd_degree_contact',
        }
      ),
    },
  };
};

export default addContactTracking;
